import { render, staticRenderFns } from "./MyCollectionsList.vue?vue&type=template&id=0a7d4094&scoped=true"
import script from "./MyCollectionsList.vue?vue&type=script&lang=js"
export * from "./MyCollectionsList.vue?vue&type=script&lang=js"
import style0 from "./MyCollectionsList.vue?vue&type=style&index=0&id=0a7d4094&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7d4094",
  null
  
)

export default component.exports